import { useState } from 'react';
import { SearchCodeModalForm } from 'src/components/common/form/search/SearchCodeModalForm';
import { SearchDateSingleForm } from 'src/components/common/form/search/SearchDateSingleForm';
import { SearchDropDownForm } from 'src/components/common/form/search/SearchDropDownForm';
import { SearchSectionForm } from 'src/components/common/form/search/SearchSectionForm';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import useUiuxStore from 'src/store/useUiuxStore';
import { useHRM2120_R01Store } from './Store_HRM2120_R01';

/** 사원 검색 조건과 기준일자를 표시한다. */
export const HRM2120_R01SearchSection = () => {
    const { HRM2120_R01Filter, setHRM2120_R01Filter } = useHRM2120_R01Store();
    const { compCdList, orgCdList, empstsCdList } = useCommonCodeStore();
    const { setCodeSearchModalProps } = useUiuxStore();
    const [visible, setVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

    /** 공통 사원 검색 팝업을 열고 선택한 사번·이름을 검색 조건에 기록한다. */
    const openEmployeeSearch = (search: string) => {
        setCodeSearchModalProps({
            category: '사원',
            search,
            formName: 'HRM2120_R01',
            isInfo: false,
            handleFoucsId: 'HRM2120_R01-employee-search',
            onConfirm: employee => setHRM2120_R01Filter({
                keyword: employee?.empNo || '',
                empNm: employee?.empNm || '',
            }),
            processType_focus: 'normal',
        });
    };
    /** DatePicker가 준 현지 날짜를 서버 요청용 yyyy-MM-dd로 바꾼다. */
    const setBaseDate = (date: Date | undefined) => {
        if (!date) return;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        setHRM2120_R01Filter({ baseDt: `${year}-${month}-${day}` });
    };

    return (
        <SearchSectionForm>
            <SearchDropDownForm
                label="사업장"
                value={HRM2120_R01Filter.compCd}
                optionList={compCdList}
                onChangeItem={item => setHRM2120_R01Filter({ compCd: item?.compCd || '' })}
            />
            <SearchDropDownForm
                label="부서"
                value={HRM2120_R01Filter.orgCd}
                optionList={orgCdList}
                onChangeItem={item => setHRM2120_R01Filter({ orgCd: item?.orgCd || '' })}
            />
            <SearchDropDownForm
                label="재직상태"
                value={HRM2120_R01Filter.empSts}
                optionList={empstsCdList}
                onChangeItem={item => setHRM2120_R01Filter({ empSts: item?.minorCd || '' })}
            />
            {/* 사원 입력란을 더블클릭하거나 Enter를 누르면 공통 검색 팝업을 연다. */}
            <SearchCodeModalForm
                label="사원"
                value={HRM2120_R01Filter.keyword}
                valueLabel={HRM2120_R01Filter.empNm}
                onChange={event => setHRM2120_R01Filter({ keyword: event.target.value, empNm: '' })}
                onDoubleClick={event => {
                    event.currentTarget.blur();
                    openEmployeeSearch(HRM2120_R01Filter.keyword);
                }}
                onKeyDown={event => {
                    if (event.key !== 'Enter') return;
                    event.preventDefault();
                    openEmployeeSearch(HRM2120_R01Filter.keyword);
                }}
            />
            <SearchDateSingleForm
                label="기준일자"
                visible={visible}
                setVisible={setVisible}
                value={HRM2120_R01Filter.baseDt
                    ? new Date(`${HRM2120_R01Filter.baseDt}T00:00:00`)
                    : undefined}
                onChange={setBaseDate}
                pickerPosition={pickerPosition}
                setPickerPosition={setPickerPosition}
            />
        </SearchSectionForm>
    );
};
